"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/client/index.ts
var client_exports = {};
__export(client_exports, {
  BillingAdminAccess: () => BillingAdminAccess,
  BillingInformationButton: () => BillingInformationButton,
  ChangePlanButton: () => ChangePlanButton,
  SubscriptionProvider: () => SubscriptionProvider,
  SubscriptionUpgradeAccess: () => SubscriptionUpgradeAccess,
  UpgradeButton: () => UpgradeButton,
  UpgradeCard: () => UpgradeCard,
  isExpertPlan: () => isExpertPlan,
  isFreePlan: () => isFreePlan,
  isPaidPlan: () => isPaidPlan,
  isProPlan: () => isProPlan,
  shouldShowUpgrade: () => shouldShowUpgrade,
  subscriptionStoreSelector: () => subscriptionStoreSelector,
  useCurrentPlan: () => useCurrentPlan,
  useCurrentPlanName: () => useCurrentPlanName,
  useSubscriptionStore: () => useSubscriptionStore,
  useSubscriptionStoreSync: () => useSubscriptionStoreSync
});
module.exports = __toCommonJS(client_exports);

// src/client/SubscriptionProvider.tsx
var import_react2 = require("react");
var import_permissions = require("@repo/permissions");

// src/client/context.ts
var import_react = require("react");
var defaultContext = {
  workspace: null
};
var SubscriptionContext = (0, import_react.createContext)(defaultContext);
var useSubscriptionContext = () => {
  const context = (0, import_react.useContext)(SubscriptionContext);
  if (!context) {
    throw new Error(
      "useSubscriptionContext must be used within a SubscriptionProvider"
    );
  }
  return context;
};
var useCurrentPlan = () => {
  const { workspace } = useSubscriptionContext();
  return (0, import_react.useMemo)(
    () => !workspace || workspace.plan === "FREE" ? void 0 : workspace.plan,
    [workspace]
  );
};
var useCurrentPlanName = () => {
  const plan = useCurrentPlan();
  return (plan ?? "FREE").toLowerCase();
};

// src/client/store/subscriptionStore/index.ts
var import_zustand = require("zustand");
var import_middleware = require("zustand/middleware");

// src/client/store/subscriptionStore/state.ts
var import_Toast = require("@repo/ui/components/Toast");

// src/api/index.ts
var import_api_client2 = require("@repo/api-client");

// src/api/api.ts
var import_api_client = require("@repo/api-client");
var subscriptionApi = {
  // subscription start
  /**
   * Create a subscription with given prices.
   * Upon success, a `clientSecret` is returned, which can be used for Stripe Elements.
   * @param data.prices
   * @param data.promoCode
   */
  createSubscription: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/create", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Check whether a subscription can be created with given prices.
   * @param data.prices the prices to create a subscription with
   */
  canCreateSubscription: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/can_create", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Fetches the subscription details for the current user/workspace.
   */
  showSubscription: async () => {
    const response = await import_api_client.apiFetchClient.GET("/subscription/show");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Fetches a preview of the subscription to reflect the changes based on the provided data.
   * @param data the data for the preview
   */
  previewSubscriptionChange: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/change_preview", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Cancels the current subscription.
   * @param data the data for the cancellation (reason)
   */
  cancelSubscription: async (data) => {
    const response = await import_api_client.apiFetchClient.POST(
      "/subscription/cancel_subscription",
      {
        body: data
      }
    );
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Schedules a cancellation of the current subscription.
   */
  cancelScheduledSubscription: async () => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/cancel_schedule");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Renews the current subscription.
   */
  renewSubscription: async () => {
    const response = await import_api_client.apiFetchClient.POST(
      "/subscription/renew_subscription"
    );
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Returns a Stripe payment intent for the last past due subscription available.
   */
  payPastDue: async () => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/pay_past_due");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Changes the current subscription.
   * @param data the data for the change (e.g. prices, promo code)
   */
  changeSubscription: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/change", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Applies a cancellation discount to the monthly subscription.
   */
  applyCancellationDiscount: async () => {
    const response = await import_api_client.apiFetchClient.POST(
      "/subscription/cancellation_discount"
    );
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Verifies a promo code for the current subscription.
   * @param code the promo code to verify
   * @param data the data for the verification (e.g. prices user selected)
   */
  verifyPromoCode: async (code, data) => {
    const response = await import_api_client.apiFetchClient.POST(
      "/subscription/promo_code/{code}",
      {
        params: { path: { code } },
        body: data
      }
    );
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Fetches the subscription prices (e.g. plan/duration combinations)
   */
  getSubscriptionPrices: async () => {
    const response = await import_api_client.apiFetchClient.GET("/subscription/prices");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  // subscription end
  // checkout start
  /**
   * Creates a Stripe portal for the current user/workspace.
   */
  createPortal: async () => {
    const response = await import_api_client.apiFetchClient.POST("/billing/portal/create");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Creates a Stripe checkout for the current user/workspace.
   * @param data the data for the checkout
   */
  createCheckout: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/billing/checkout/create", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Fetches the latest invoice for the current user/workspace.
   */
  getLatestInvoice: async () => {
    const response = await import_api_client.apiFetchClient.GET("/billing/invoice", {
      params: { query: { latestFromSubscription: "t" } }
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  // checkout end
  // products
  /**
   * Fetches a list of products from the server.
   *
   * The products represent AI Credits Plans, which vary depending on the user's subscription plan or eligibility.
   */
  getProducts: async () => {
    const response = await import_api_client.apiFetchClient.GET("/products/index", {
      params: {
        query: { type: import_api_client.PathsProductsIndexGetParametersQueryType.CREDITS }
      }
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Creates a new order on the server.
   *
   * This function generates a new order based on the provided data and fetches a Stripe checkout link
   * for completing the purchase.
   *
   * @param data - The data for the order, adhering to the `OrderData` type.
   */
  createOrder: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/orders/oneclick/create", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  }
};
var SubscriptionPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  EXPERT: "EXPERT"
};
var SubscriptionTierType = {
  ...SubscriptionPlanType,
  BUSINESS: "BUSINESS"
};

// src/client/store/subscriptionStore/state.ts
var initialState = {
  /**
   * whether the store was initialized
   */
  isInitialized: false,
  /**
   * stores the userId for which the store was initialized for
   * this is used to only initialize once for a user
   */
  initializedForEntityId: null,
  /**
   * stores link to the billing portal
   */
  /**
   * information about the users subscription
   */
  subscription: null,
  /**
   * information about subscription prices
   */
  subscriptionPrices: [],
  /**
   * the country the user is in
   */
  requestCountry: null,
  /**
   * the country of the stripe account
   */
  stripeAccountCountry: null
};
var stateCreator = (set, get) => ({
  ...initialState,
  /**
   * load relevant billing urls that are unique for a user
   */
  init: async (entityId) => {
    set({ isInitialized: false });
    if (!entityId) {
      get().reset();
      await Promise.all([
        get().loadSubscription(),
        get().loadSubscriptionPrices()
      ]);
      set({ isInitialized: true });
      return;
    }
    if (get().initializedForEntityId === entityId) {
      set({ isInitialized: true });
      return;
    }
    await Promise.all([
      get().loadSubscription(),
      get().loadSubscriptionPrices()
    ]);
    set({ isInitialized: true, initializedForEntityId: entityId });
  },
  // @TODO: Cache these for 5 minutes
  createPortalURL: async () => {
    const res = await subscriptionApi.createPortal();
    if (res.success) {
      return res.redirectUrl;
    } else if ("error" in res) {
      throw new Error(res.error);
    }
    return null;
  },
  openBillingPortal: async () => {
    try {
      const portalUrl = await get().createPortalURL();
      if (portalUrl) {
        window.open(portalUrl, "_blank");
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : error;
      console.error(errorMessage);
      get().onErrorHandler(errorMessage);
    }
  },
  /**
   * reset user-specific state
   */
  reset: () => {
    const { requestCountry, subscriptionPrices } = get();
    set({ ...initialState, requestCountry, subscriptionPrices });
  },
  /**
   * the function to handle errors
   */
  onErrorHandler: () => {
  },
  /**
   * the function to show the upgrade modal
   */
  showUpgradeModal: (type, options) => {
  },
  /**
   * load and store subscription data for the current user
   */
  loadSubscription: async () => {
    const result = await subscriptionApi.showSubscription();
    if ("subscription" in result) {
      set({ subscription: result.subscription });
      return result.subscription;
    }
    return null;
  },
  /**
   * Pay past due: get the associated payment intent id and secret to pay a past due subscription
   */
  getPastDuePaymentIntent: async () => {
    return await subscriptionApi.payPastDue();
  },
  /**
   * update the stored subscription data
   */
  updateSubscription: async (data) => {
    if (!data) {
      await get().loadSubscription();
      return;
    }
    set({ subscription: data });
  },
  loadSubscriptionPrices: async () => {
    const result = await subscriptionApi.getSubscriptionPrices();
    if ("data" in result) {
      const prices = result.data.subscriptionPrices;
      const { requestCountry, stripeAccountCountry } = result.data;
      set({
        subscriptionPrices: prices,
        requestCountry,
        stripeAccountCountry
      });
      return prices;
    } else {
      (0, import_Toast.fireToast)({
        label: "Failed to load subscription prices.",
        error: true
      });
      return [];
    }
  }
});

// src/client/store/subscriptionStore/selector.ts
var subscriptionStoreSelector = {
  isInitialized: (state) => state.isInitialized,
  /**
   * load relevant billing urls that are unique for a user
   * @param {string} userId
   */
  init: (state) => state.init,
  /**
   * reset user-specific state
   */
  reset: (state) => state.reset,
  /**
   * load and store subscription data for the current user
   * @returns {Promise<Subscription>}
   */
  loadSubscription: (state) => state.loadSubscription,
  /**
   * create a billing portal URL for the user and opens it
   * @param state
   * @returns {Promise<string | null>}
   */
  openBillingPortal: (state) => state.openBillingPortal,
  /**
   * update the stored subscription data
   * @param {Subscription} data
   */
  updateSubscription: (state) => state.updateSubscription,
  /**
   * get the current subscription of the user
   * @returns {Subscription}
   */
  subscription: (state) => state.subscription,
  /**
   * get the past due payment info
   * @returns {PaymentInfo}
   */
  getPastDuePaymentIntent: (state) => state.getPastDuePaymentIntent,
  subscriptionPrices: (state) => state.subscriptionPrices,
  loadSubscriptionPrices: (state) => state.loadSubscriptionPrices,
  requestCountry: (state) => state.requestCountry,
  showUpgradeModal: (state) => state.showUpgradeModal
};

// src/client/store/subscriptionStore/index.ts
var useSubscriptionStore = (0, import_zustand.create)((0, import_middleware.subscribeWithSelector)(stateCreator));

// src/client/SubscriptionProvider.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var SubscriptionProvider = ({
  children,
  workspace,
  captureException,
  showUpgradeModal
}) => {
  const workspaceId = workspace?.id ?? null;
  (0, import_react2.useEffect)(() => {
    useSubscriptionStore.getState().init(workspaceId);
  }, [workspaceId]);
  (0, import_react2.useEffect)(() => {
    useSubscriptionStore.setState({
      onErrorHandler: captureException,
      showUpgradeModal: (type, options) => showUpgradeModal(type, options)
    });
  }, [captureException, showUpgradeModal]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SubscriptionContext.Provider, { value: { workspace }, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_permissions.ResourceInfoWrapper,
    {
      ...{
        [import_permissions.ResourceType.workspace]: workspace?.id
      },
      children
    }
  ) });
};

// src/client/UpgradeCard/UpgradeCard.tsx
var import_permissions2 = require("@repo/permissions");
var import_Card = require("@repo/ui-kit/components/core/Card");
var import_Typography = require("@repo/ui-kit/components/core/Typography");
var import_themeStyle = require("@repo/ui-kit/themeStyle");

// src/client/utils.ts
var shouldShowUpgrade = (plan) => {
  return plan !== SubscriptionPlanType.EXPERT;
};
var isFreePlan = (plan) => {
  return !plan || plan === SubscriptionPlanType.FREE;
};
var isProPlan = (plan) => {
  return plan === SubscriptionPlanType.PRO;
};
var isExpertPlan = (plan) => {
  return plan === SubscriptionPlanType.EXPERT;
};
var isPaidPlan = (plan) => {
  return !isFreePlan(plan);
};

// src/client/SubscriptionUpgradeAccess/SubscriptionUpgradeAccess.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var SubscriptionUpgradeAccess = ({
  children
}) => {
  const currentPlan = useCurrentPlan();
  if (!shouldShowUpgrade(currentPlan)) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_jsx_runtime2.Fragment, { children });
};

// src/client/UpgradeCard/UpgradeCard.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var ViewOnlyBanner = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
    "div",
    {
      "data-testid": "subscription--upgrade-card--view-only-banner",
      style: {
        display: "flex",
        flexDirection: "column",
        gap: import_themeStyle.themeStyle.spacing8,
        borderRadius: import_themeStyle.themeStyle.borderRadius8,
        padding: import_themeStyle.themeStyle.spacing12,
        backgroundColor: import_themeStyle.themeStyle.colorBgFillInfoSecondary
      },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_Typography.H6, { bold: true, children: "View-only access" }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_Typography.P3, { color: "secondary", children: "You can view projects in this team but cannot create or edit them." })
      ]
    }
  );
};
var UpgradeCard = ({ children }) => {
  const currentPlan = useCurrentPlan();
  const title = isPaidPlan(currentPlan) ? "Pro plan" : "Get Pro Templates";
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(SubscriptionUpgradeAccess, { children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    import_permissions2.PermissionsCheck,
    {
      fallback: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(ViewOnlyBanner, {}),
      requires: import_permissions2.ResourcePermissions.DESIGN_EDIT,
      resourceType: import_permissions2.ResourceType.workspace,
      children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_Card.StandardCard, { dataTestId: "subscription--upgrade-card", children: /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_Card.StandardCard.Content, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_Card.StandardCard.ContentTitle, { title }),
        /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
          import_Card.StandardCard.ContentSubtitle,
          {
            subtitle: "Unlimited projects, AI credits, vector export & more!",
            textOverflowEllipsis: false
          }
        ),
        children
      ] }) })
    }
  ) });
};

// src/client/UpgradeButton/UpgradeButton.tsx
var import_IconPremiumColored = __toESM(require("@repo/ui-icons/IconPremiumColored"));
var import_Button = require("@repo/ui-kit/components/core/Button");

// src/client/BillingAdminAccess/BillingAdminAccess.tsx
var import_permissions3 = require("@repo/permissions");
var import_jsx_runtime4 = require("react/jsx-runtime");
var BillingAdminAccess = ({ children, fallback }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    import_permissions3.PermissionsCheck,
    {
      fallback,
      requires: import_permissions3.ResourcePermissions.BILLING_ADMIN,
      resourceType: import_permissions3.ResourceType.workspace,
      children
    }
  );
};

// src/client/UpgradeButton/UpgradeButton.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var UpgradeButton = ({
  onAfterUpgradeClick,
  showIcon = true,
  hideForPaidPlans = false,
  ...buttonProps
}) => {
  const showUpgradeModal = useSubscriptionStore(
    subscriptionStoreSelector.showUpgradeModal
  );
  const currentPlan = useCurrentPlan();
  const handleUpgrade = () => {
    showUpgradeModal("noIncentiveUpgrade", {
      trackingLabel: "upgradeButtonClick"
    });
    onAfterUpgradeClick?.();
  };
  if (hideForPaidPlans && isPaidPlan(currentPlan)) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(SubscriptionUpgradeAccess, { children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(BillingAdminAccess, { children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    import_Button.Button,
    {
      leftIcon: showIcon ? import_IconPremiumColored.default : void 0,
      name: "upgradePlanButton",
      size: "s",
      variant: "secondary",
      width: "fit-content",
      onClick: handleUpgrade,
      ...buttonProps,
      children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_Button.Button.Label, { children: "Upgrade plan" })
    }
  ) }) });
};

// src/client/ChangePlanButton/ChangePlanButton.tsx
var import_Button2 = require("@repo/ui-kit/components/core/Button");
var import_jsx_runtime6 = require("react/jsx-runtime");
var ChangePlanButton = ({
  ...buttonProps
}) => {
  const currentPlan = useCurrentPlan();
  if (isFreePlan(currentPlan)) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(BillingAdminAccess, { children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    import_Button2.Button,
    {
      name: "upgradePlanButton",
      size: "s",
      variant: "secondary",
      width: "fit-content",
      ...buttonProps,
      children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_Button2.Button.Label, { children: "Change plan" })
    }
  ) });
};

// src/client/BillingInformationButton/BillingInformationButton.tsx
var import_react3 = require("react");
var import_Button3 = require("@repo/ui-kit/components/core/Button");
var import_jsx_runtime7 = require("react/jsx-runtime");
var BillingInformationButton = (props) => {
  const [isLoading, setIsLoading] = (0, import_react3.useState)(false);
  const openBillingPortal = useSubscriptionStore(
    subscriptionStoreSelector.openBillingPortal
  );
  const currentPlan = useCurrentPlan();
  const handleClick = async () => {
    setIsLoading(true);
    await openBillingPortal();
    setIsLoading(false);
  };
  if (!currentPlan) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(BillingAdminAccess, { children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    import_Button3.Button,
    {
      isLoading,
      name: "billingInformationButton",
      onClick: handleClick,
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_Button3.Button.Label, { children: "Billing Information" })
    }
  ) });
};

// src/client/hooks/useSubscriptionStoreSync.ts
var import_react4 = require("react");
var useSubscriptionStoreSync = (workspaceId) => {
  const initializedForEntityId = useSubscriptionStore(
    (state) => state.initializedForEntityId
  );
  const isInitialized = useSubscriptionStore((state) => state.isInitialized);
  return (0, import_react4.useMemo)(() => {
    return !!(workspaceId && initializedForEntityId === workspaceId && isInitialized);
  }, [workspaceId, initializedForEntityId, isInitialized]);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BillingAdminAccess,
  BillingInformationButton,
  ChangePlanButton,
  SubscriptionProvider,
  SubscriptionUpgradeAccess,
  UpgradeButton,
  UpgradeCard,
  isExpertPlan,
  isFreePlan,
  isPaidPlan,
  isProPlan,
  shouldShowUpgrade,
  subscriptionStoreSelector,
  useCurrentPlan,
  useCurrentPlanName,
  useSubscriptionStore,
  useSubscriptionStoreSync
});
